<template>
  <div class="el-tabs__active-bar-custom" :class="`is-${ rootTabs.tabPosition }`" :style="barStyle"></div>
</template>
<script>
  import { arrayFind } from 'element-ui/src/utils/util';
  export default {
    name: 'TabBar',
    props: {
      tabs: Array
    },
    inject: ['rootTabs'],
    computed: {
      barStyle: {
        get() {
          let style = {};
          let offset = 0;
          let tabSize = 0;
          const sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
          const sizeDir = sizeName === 'width' ? 'x' : 'y';
          const firstUpperCase = str => {
            return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
          };
          this.tabs.every((tab, index) => {
            let $el = arrayFind(this.$parent.$refs.tabs || [], t => t.id.replace('tab-', '') === tab.paneName);
            if (!$el) { return false; }
            if (!tab.active) {
              offset += $el[`client${firstUpperCase(sizeName)}`];
              return true;
            } else {
              tabSize = $el[`client${firstUpperCase(sizeName)}`];
              const tabStyles = window.getComputedStyle($el);
              if (sizeName === 'width' && this.tabs.length > 1) {
                tabSize -= parseFloat(tabStyles.paddingLeft) + parseFloat(tabStyles.paddingRight);
              }
              if (sizeName === 'width') {
                const padding = this.$rtl.isRTL ? tabStyles.paddingRight : tabStyles.paddingLeft
                offset += parseFloat(padding);
              }
              return false;
            }
          });
          const barLineDirection = this.$rtl.isRTL ? '-' : ''

          const transform = `translate${firstUpperCase(sizeDir)}(${barLineDirection}${offset}px)`;
          style[sizeName] = tabSize + 'px';
          style.transform = transform;
          style.msTransform = transform;
          style.webkitTransform = transform;
          return style;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.el-tabs__active-bar-custom {
  position: absolute;
  bottom: 0;
  // left: 0;
  height: 2px;
  background-color: var(--primary-color);
  z-index: 1;
  -webkit-transition: -webkit-transform .3s cubic-bezier(.645,.045,.355,1);
  transition: -webkit-transform .3s cubic-bezier(.645,.045,.355,1);
  transition: transform .3s cubic-bezier(.645,.045,.355,1);
  transition: transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);
  list-style: none
}
[dir="ltr"] .el-tabs__active-bar-custom {
  left: 0;
}
[dir="rtl"] .el-tabs__active-bar-custom {
  right: 0;
}
</style>